import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SetShippingAddressForm from './SetShippingAddressForm';
import { RenderSubmitButton } from '../../common/form';
import { showModal } from '../../../actions/ModalActions';
import { updateRegistryPublish } from '../../../actions/RegistryActions';

function ShippingAddressSubmitButton({ valid, pristine, submitting, value }) {
  return (
    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton pristine={pristine} disabled={submitting} valid={valid || true} className="btn btn-wide" value={value} />
    </div>
  );
}

ShippingAddressSubmitButton.propTypes = {
  valid: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  value: PropTypes.string,
};

function SetShippingAddressModal({ onSetShippingAddressSuccess, valid, pristine, submitting }) {
  const shippingAddressSubmitButton = (
    <ShippingAddressSubmitButton
      pristine={pristine}
      disabled={submitting}
      valid={valid || true}
      className="btn btn-wide set-shipping-address"
      value="Set Shipping Address"
    />
  );

  return (
    <div id="set-shipping-address-modal">
      <div className="modal-header">
        <h3 className="modal-title margin-bottom">Shipping Information</h3>
      </div>
      <div className="modal-body">
        <p>Please provide the address where you&#39;d like your wedding gifts to be shipped. This is required to make your registry visible to guests.</p>
        <SetShippingAddressForm
          onSuccess={onSetShippingAddressSuccess}
          submitButtonText="Set Shipping Address"
          shippingAddressSubmitButton={shippingAddressSubmitButton}
        />
      </div>
    </div>
  );
}

SetShippingAddressModal.propTypes = {
  valid: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  onSetShippingAddressSuccess: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  onSetShippingAddressSuccess: () => dispatch(updateRegistryPublish(true)).then(() => dispatch(showModal('PUBLISH_REGISTRY'))),
});

export default connect(
  null,
  mapDispatchToProps
)(SetShippingAddressModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/SetShippingAddressModal.jsx
 **/